import { render, staticRenderFns } from "./ctaSmall.vue?vue&type=template&id=7eab5ba4"
import script from "./ctaSmall.vue?vue&type=script&lang=js"
export * from "./ctaSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/vercel/path0/components/ui/link.vue').default})
